import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Row
} from "reactstrap";

import NotificationAlert from "react-notification-alert";
import { useNavigate } from "react-router-dom";

import { login } from "actions/public";
import {
  DEFAULT_ROUTES,
  REGEX,
  ROLES
} from "components/Common/constants";

import Slide1 from "assets/img/2.png";
import Slide2 from "assets/img/3.png";
import Slide3 from "assets/img/4.png";
import Logo from "assets/img/icon-transparent.png";
import CustomLogo from "assets/img/cust-transparent-icon-1024.png";
import SignUp from "./SignUp";
import { AUTH_MODE } from "components/Common/constants";

const slides = [
  {
    image: Slide1,
    title: "Repair Any Kitchen Equipment Hassle-Free",
    description:
      "Book service requests for all your commercial kitchen equipment in just a few clicks."
  },
  {
    image: Slide2,
    title: "Track Every Step in Real Time",
    description:
      "Stay updated from service request creation to technician arrival and repair completion."
  },
  {
    image: Slide3,
    title: "Get Quotations & Manage Everything",
    description:
      "View quotations, approve repairs, download invoices and manage your equipment history."
  }
];

const Login = () => {

  const navigate = useNavigate();

  const notificationAlertRef = useRef(null);

  const [currentSlide, setCurrentSlide] = useState(0);

  const [showPassword, setShowPassword] = useState(false);

  const [showLoaderOnClick, setShowLoaderOnClick] = useState(false);

  const [loginInfo, setLoginInfo] = useState({
    email: {
      value: "",
      error: ""
    },
    password: {
      value: "",
      error: ""
    }
  });

  const [authMode, setAuthMode] = useState(AUTH_MODE.LOGIN);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide(prev =>
        prev === slides.length - 1 ? 0 : prev + 1
      );
    }, 5000);
    return () => clearInterval(interval);
  }, []);


  const notify = (type, message) => {
    const options = {
      place: "tr",
      message: <div>{message}</div>,
      type,
      icon: "tim-icons icon-bell-55",
      autoDismiss: 5,
    };
    notificationAlertRef.current.notificationAlert(options);
  };

  const handleChange = (name, value) => {
    setLoginInfo((prev) => ({
      ...prev,
      [name]: { ...prev[name], value: value.trim(), error: "" },
    }));
  };

  const preventSpace = (e) => {
    if (e.key === " ") {
      e.preventDefault(); // Prevent space from being typed
    }
  };

  const handleBlur = (name, value) => {
    switch (name) {
      case "email": {
        if (value === "") {
          setLoginInfo((prev) => ({
            ...prev,
            email: { ...prev.email, error: "Email is required" },
          }));
          return true;
        } else if (!REGEX.EMAIL_REGEX.test(value)) {
          setLoginInfo((prev) => ({
            ...prev,
            email: { ...prev.email, error: "Please enter a valid email" },
          }));
          return true;
        }
        break;
      }
      case "password": {
        if (value === "") {
          setLoginInfo((prev) => ({
            ...prev,
            password: { ...prev.password, error: "Password is required" },
          }));
          return true;
        }
        break;
      }
      default:
        return;
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    if (
      handleBlur("email", loginInfo.email.value) ||
      handleBlur("password", loginInfo.password.value)
    )
      return;

    try {
      setShowLoaderOnClick(true);
      const loginData = {
        email: loginInfo.email.value,
        password: loginInfo.password.value,
      };
      const res = await login(loginData);

      if (res.code === 200) {
        if (
          res.data.role !== ROLES.CUSTOMER
        ) {
          notify("danger", "Invalid credentials");
          return;
        }
        let userData = res.data;

        notify("success", res.message || "Login successful");
        localStorage.setItem("p", JSON.stringify(userData));

        const matchedKey = Object.keys(ROLES).find(
          (key) => ROLES[key] === userData.role
        );

        const redirect = DEFAULT_ROUTES[matchedKey] || "/customer/dashboard";
        setTimeout(() => {
          navigate(redirect);
        }, 1000);
      } else {
        const message = Array.isArray(res?.message)
          ? res?.message[0]?.Msg
          : res?.message || "Sign in failed";
        notify("danger", message);
      }
    } catch (e) {
      notify("danger", "Sign in failed");
    } finally {
      setShowLoaderOnClick(false);
    }
  };

  return (
    <>
      <div className="rna-container">
        <NotificationAlert ref={notificationAlertRef} />
      </div>

      <div className="customer-login-page">
        <Container fluid>
          <Row className="min-vh-100">
            {/* LEFT PANEL */}
            <Col
              lg="7"
              className="left-section"
            >
              <div className="left-content">
                <div className="brand">
                  <div className="brand-logo">
                    <img src={Logo} />
                  </div>
                  <div>
                    <h3 className="text-deep-blue">
                      Falcon Kitchens
                    </h3>
                    <span>
                      Customer Portal
                    </span>
                  </div>
                </div>

                <div className="left-text">
                  <h1>
                    {slides[currentSlide].title}
                  </h1>
                  <p>
                    {slides[currentSlide].description}
                  </p>
                </div>

                <div className="left-features">
                  <div>
                    <i className="fa fa-check-circle" />
                    Book Service
                  </div>

                  <div>
                    <i className="fa fa-check-circle" />
                    Track Progress
                  </div>

                  <div>
                    <i className="fa fa-check-circle" />
                    View Quotations
                  </div>

                  <div>
                    <i className="fa fa-check-circle" />
                    Download Invoices
                  </div>
                </div>

                <div className="left-image">
                  <img
                    src={slides[currentSlide].image}
                    alt=""
                  />
                </div>
              </div>
            </Col>

            <Col
              lg="5"
              className="login-section"
            >
              {authMode === AUTH_MODE.REGISTER ? <SignUp setAuthMode={setAuthMode} /> : <div className="login-card">
                <div className="login-header">
                  <div className="logo-container">
                    <img
                      src={CustomLogo}
                      alt=""
                      className="cust-logo"
                    />
                    <span className="cust-head">Falcon Customer</span>
                  </div>
                  <h2 className="text-center mb-0 pb-0 text-deep-blue">
                    Sign In
                    {/* Welcome Back */}
                  </h2>
                  <p className="text-center mt-3 mb-0">
                    Expert service at your doorstep.
                    {/* Sign in to manage your kitchen service requests,
                    quotations and equipment. */}
                  </p>
                </div>

                <Form onSubmit={handleLogin}>
                  <div className="login-form">
                    {/* Email */}
                    <FormGroup className={`modern-form-group ${loginInfo.email.error ? "has-danger" : ""
                      }`}>
                      {/* <label>Email Address</label> */}

                      <div className="modern-input">
                        <i className="fa fa-envelope input-icon" />
                        <Input
                          type="email"
                          name="email"
                          placeholder="Enter your email"
                          value={loginInfo.email.value}
                          onKeyDown={preventSpace}
                          onChange={(e) =>
                            handleChange(e.target.name, e.target.value)
                          }
                          onBlur={(e) =>
                            handleBlur(e.target.name, e.target.value)
                          }
                        />
                      </div>
                      {loginInfo.email.error && (
                        <small className="validation-error">
                          {loginInfo.email.error}
                        </small>
                      )}
                    </FormGroup>

                    {/* Password */}

                    <FormGroup className={`modern-form-group mt-4 ${loginInfo.password.error ? "has-danger" : ""
                      }`}>
                      {/* <label>Password</label> */}
                      <div className="modern-input">
                        <i className="fa fa-lock input-icon" />
                        <Input
                          type={showPassword ? "text" : "password"}
                          name="password"
                          placeholder="Enter your password"
                          value={loginInfo.password.value}
                          onKeyDown={preventSpace}
                          onChange={(e) =>
                            handleChange(e.target.name, e.target.value)
                          }
                          onBlur={(e) =>
                            handleBlur(e.target.name, e.target.value)
                          }
                        />

                        <button
                          type="button"
                          className="password-toggle"
                          onClick={() =>
                            setShowPassword(!showPassword)
                          }
                        >
                          <i
                            className={
                              showPassword
                                ? "fa fa-eye"
                                : "fa fa-eye-slash"
                            }
                          />
                        </button>

                      </div>

                      {loginInfo.password.error && (
                        <small className="validation-error">
                          {loginInfo.password.error}
                        </small>
                      )}

                    </FormGroup>
                    {/* Forgot Password */}

                    <div className="forgot-password">
                      <a
                        href="/user-reset-password"
                        onClick={(e) => {
                          e.preventDefault();
                          navigate("/user-reset-password");
                        }}
                      >
                        Forgot Password?
                      </a>
                    </div>

                    {/* Login Button */}
                    <Button
                      color="cyan"
                      block
                      size="lg"
                      type="submit"
                      className="login-btn"
                      disabled={showLoaderOnClick}
                    >

                      {showLoaderOnClick ? (
                        <>
                          <i className="fa fa-spinner fa-spin mr-2" />
                        </>
                      ) : (
                        <>
                          Sign In
                        </>
                      )}

                    </Button>

                    {/* <Button
                      color="link"
                      block
                      type="button"
                      className="signup-btn mt-3"
                    >
                      Don't have an account?{" "}
                      <span className="signup-text" onClick={() => {
                        setAuthMode(AUTH_MODE.REGISTER)
                      }}>Sign Up</span>
                    </Button> */}

                    {/* <div className="signup-btn mt-3">
                      Don't have an account?{" "}
                      <span
                        onClick={() => {
                          setAuthMode(AUTH_MODE.REGISTER)
                        }}
                      >
                        Sign Up
                      </span>
                    </div> */}

                    {/* Security */}
                    {/* <div className="secure-login">
                      <i className="fa fa-shield-alt" />
                      <span>
                        Secure login. Your service history and documents are
                        protected.
                      </span>
                    </div> */}

                    {/* Divider */}
                    {/* <div className="login-divider">
                      <span>Need Help?</span>
                    </div> */}
                    {/* Bottom Links */}
                    {/* <div className="bottom-links">
                      <a
                        href="/privacy-policy"
                        onClick={(e) => {
                          e.preventDefault();
                          navigate("/privacy-policy");
                        }}
                      >
                        Privacy Policy
                      </a>

                      <span>|</span>

                      <a href="mailto:support@falconkitchen.com">
                        Contact Support
                      </a>

                    </div> */}

                  </div>
                </Form>

              </div>}
            </Col>
          </Row>

        </Container>

      </div>

    </>
  );
}

export default Login;